import API from "./api";

// 🔥 GET COMPLAINTS
export const getComplaints = () => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.get("/school-admin/complaints/", {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};

// 🔥 UPDATE COMPLAINT (status or reply)
export const updateComplaint = (id, data) => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.post(`/school-admin/complaints/update/${id}/`, data, {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};